export default __webpack_public_path__ + "static/media/cny-lucky-draw.0e74a9a7.webp";